import { useRef } from 'react';
import { generateRandomId } from 'utils/random';

export const useId = (prefix = '') => {
  const id = useRef(`${prefix}${generateRandomId()}`);
  return id.current;
};
